import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_BUY_IN_RESOURCE } from "./use-vehicle-buy-in-create-data.query";

export const VEHICLE_BUY_IN_CANCEL_API_PATH = "/v1/vehicle-buy-in/{uuid}/cancel" as const;

export type VehicleBuyInCancelParameters = paths[typeof VEHICLE_BUY_IN_CANCEL_API_PATH]["patch"]["parameters"]["path"];
export type VehicleBuyInCancelResponse =
  paths[typeof VEHICLE_BUY_IN_CANCEL_API_PATH]["patch"]["responses"][202]["content"]["application/json"];

export function useVehicleBuyInCancelMutation() {
  const queryClient = useQueryClient();

  return useMutation<VehicleBuyInCancelResponse, Error, VehicleBuyInCancelParameters>({
    mutationFn: async ({ uuid }) => {
      const apiPath = VEHICLE_BUY_IN_CANCEL_API_PATH.replace("{uuid}", uuid);
      const response = await alphartisApiAxios.patch<VehicleBuyInCancelResponse>(apiPath);

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [VEHICLE_BUY_IN_RESOURCE] });
    },
  });
}
